import { PlayerType } from '../../constants';
import { InitPlayerPayload, IPlayer } from '../../types';

export default class PlayerAdapter implements IPlayer {
    private _playerObj: InitPlayerPayload;

    constructor(player: InitPlayerPayload) {
        this._playerObj = player;
    }

    pause = () => {
        switch (this._playerObj.type) {
            case PlayerType.YOUTUBE: {
                this._playerObj.player?.pauseVideo();
                break;
            }

            case PlayerType.TWITCH: {
                this._playerObj.player?.pause();
                break;
            }

            default: {
                break;
            }
        }
    };
}
